import { useMemo } from 'react';
import { StoreInventoryRow } from 'src/domain/table/store-inventory.row';
import { useStoreInventoryUnsavedChanges } from '../save-changes/useStoreInventoryUnsavedChanges';
import { useStoreInventoryRows } from './useStoreInventoryRows';

export const createStoreInventorySimulationRows = (
    rows: StoreInventoryRow[],
    unsavedChanges: Map<number, Partial<StoreInventoryRow>>
): StoreInventoryRow[] => {
    return rows.map((row) => {
        const unsavedChange = unsavedChanges.get(row.id);
        const furnitureColumns = {
            ...row.furnitureColumns,
            ...unsavedChange?.furnitureColumns,
        };

        return {
            ...row,
            furnitureColumns: Object.fromEntries(
                Object.entries(furnitureColumns).map(([key, value]) => [key, { ...value }])
            ),
        };
    });
};

export const useStoreInventorySimulationRows = (includeFurnitureZones = false) => {
    const {
        data: rows,
        loading,
        furnitureColumns,
        furnitureZoneColumns,
        furnitureTypeColorPalette,
    } = useStoreInventoryRows(includeFurnitureZones);
    const [unsavedChanges, setUnsavedChanges] = useStoreInventoryUnsavedChanges();

    const simulationRows = useMemo(
        () => createStoreInventorySimulationRows(rows, unsavedChanges),
        [rows, unsavedChanges]
    );

    return {
        data: simulationRows,
        loading,
        setUnsavedChanges,
        furnitureColumns,
        furnitureZoneColumns,
        furnitureTypeColorPalette,
    };
};
